import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';

const RecipeDetail = ({ recipes }) => {
  const { id } = useParams();
  const recipe = recipes.find(r => r.id === id);

  if (!recipe) return <div>Recipe not found</div>;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="max-w-4xl mx-auto">
      <Card className="print:shadow-none print:border-none">
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle className="text-3xl">{recipe.name}</CardTitle>
            <Button 
              onClick={handlePrint}
              className="print:hidden"
            >
              Print Recipe
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="relative h-[400px] w-full overflow-hidden rounded-lg">
              <img
                src={recipe.image}
                alt={recipe.name}
                className="object-cover w-full h-full"
              />
            </div>
            
            <div className="flex gap-4 text-sm text-gray-500">
              <div>Prep Time: {recipe.prepTime}</div>
              <div>Cook Time: {recipe.cookTime}</div>
              <div>Servings: {recipe.servings}</div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Description</h3>
              <p className="text-gray-600">{recipe.description}</p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-2">Ingredients</h3>
              <ul className="list-disc pl-5 space-y-1">
                {recipe.ingredients.map((ingredient, index) => (
                  <li key={index}>{ingredient}</li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2">Instructions</h3>
              <ol className="list-decimal pl-5 space-y-2">
                {recipe.instructions.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RecipeDetail;